import Button from '@cobliteam/ui/components/Button';
import Dropdown from '@cobliteam/ui/components/Dropdown';
import Checkbox from '@cobliteam/ui/form/Checkbox';
import Label from '@cobliteam/ui/form/Label';
import Icon from '@cobliteam/ui/icons';
import { useEffect, useState } from 'react';

export const DEFAULT_FUEL_TYPE_OPTIONS = ['Gasolina', 'Etanol', 'Diesel', 'GNV', 'Outros'];

interface MultiSelectFuelTypeProps {
  size?: 'sm' | 'md';
  selectedOptions: string[];
  options?: string[];
  isOpen?: boolean;
  titleComponent?: React.ReactNode;
  onClick?: () => void;
  onChange: (fuelTypes: string[]) => void;
}

const MultiSelectFuelType = ({
  size = 'sm',
  selectedOptions,
  options = DEFAULT_FUEL_TYPE_OPTIONS,
  isOpen,
  titleComponent,
  onClick: onDropdownClick,
  onChange,
}: MultiSelectFuelTypeProps) => {
  const [forceClosed, setForceClosed] = useState(false);
  const [draft, setDraft] = useState<string[]>(selectedOptions || []);

  const hasSameElements = selectedOptions?.length === draft?.length && Array.from(selectedOptions ?? []).every((value) => draft.includes(value));

  const handleOpenChange = () => {
    onDropdownClick?.();
    setDraft(selectedOptions || []);
  };

  const handleClose = () => {
    setForceClosed(true);
    setDraft(selectedOptions || []);
  };

  const handleApply = () => {
    onChange(draft);
    handleClose();
  };

  const toggleItem = (item: string) => {
    const isSelected = draft.includes(item);
    const updated = isSelected ? draft.filter((d) => d !== item) : [...draft, item];
    setDraft(updated);
  };

  useEffect(() => {
    setForceClosed(!isOpen);
  }, [isOpen]);

  useEffect(() => {
    if (forceClosed) setForceClosed(false);
  }, [forceClosed]);

  const countLabel = selectedOptions?.length > 0 ? ` (${selectedOptions.length})` : '';

  return (
    <Dropdown
      portal={false}
      onOpenChange={handleOpenChange}
      forceClose={forceClosed}
      overlay={
        <Dropdown.Overlay>
          <Dropdown.Header className='px-2'>
            <Button variant='ghost' size='sm' disabled={draft?.length === 0} onClick={() => setDraft([])}>
              Limpar seleção
            </Button>
          </Dropdown.Header>
          <Dropdown.Body className='px-2'>
            <Dropdown.List
              heightList={Math.min(options.length * 32, 300)}
              heightItem={28}
              data={options}
              itemComponent={(item: string) => (
                <div className='flex items-center gap-2'>
                  <Checkbox id={`fuel-type-${item}`} checked={draft.includes(item)} onCheckedChange={() => toggleItem(item)} />
                  <Label htmlFor={`fuel-type-${item}`}>{item}</Label>
                </div>
              )}
            />
          </Dropdown.Body>
          <Dropdown.Footer>
            <Dropdown.Actions className='px-2'>
              <Button variant='ghost' full size='sm' onClick={handleClose}>
                Cancelar
              </Button>
              <Button size='sm' full onClick={handleApply} disabled={hasSameElements}>
                Aplicar
              </Button>
            </Dropdown.Actions>
          </Dropdown.Footer>
        </Dropdown.Overlay>
      }
    >
      <div>
        {titleComponent || (
          <Button size={size} variant='ghost' startIcon={<Icon name='fuel' />}>
            Combustível{countLabel}
          </Button>
        )}
      </div>
    </Dropdown>
  );
};

export default MultiSelectFuelType;
